import { ConfirmResetPasswordForm } from './components/confirm-reset-password-form';
import { Schema } from './components/confirm-reset-password-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useConfirmPasswordResetMutation } from '../mutations';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { tokenSchema } from '~/schemas';

export function Page() {
  const { token } = useParams(tokenSchema.parse);

  const mutation = useConfirmPasswordResetMutation();
  const navigate = useNavigate();

  async function handleSubmit(payload: Schema) {
    try {
      await mutation.mutateAsync({ token, ...payload });
      navigate('/auth/reset-password/confirm/success');
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      navigate('/auth/reset-password/confirm/error');
    }
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Sätt nytt lösenord" />
      <ConfirmResetPasswordForm onSubmit={handleSubmit} isLoading={mutation.isPending} />
    </Fragment>
  );
}
